import { DurationTypes } from '@/models/catalog/course';

/**
 * @desc Converts a duration of time into a humanized format
 * @param {string} unit - The unit of time to be formatted (day, week, month, etc).
 * @param {number} value - The value of time to be formatted
 * @param {string} locale - The locale to be used, defaults to 'pt-BR'.
 * @returns {string} The formatted time.
 * @example
 * // duration is '1 mês'
 * formatDuration('month', 1);
 */
export const formatDuration = (
  unit: DurationTypes,
  value: number,
  locale: string = 'pt-BR'
): string => {
  const durationLabel = getDurationLabel(unit, Number(value), locale);

  return `${value} ${durationLabel}`;
};

export const getDurationLabel = (
  unit: DurationTypes,
  value: number,
  locale = 'pt-BR'
) => {
  if (unit === 'semester') {
    return Number(value) > 1 ? 'semestres' : 'semestre';
  }

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'always' });
  const parts = rtf.formatToParts(Number(value), unit);
  const durationLiteral = parts.filter((part) => part.type == 'literal').pop();

  return durationLiteral?.value?.trim();
};

export const durationInMonths = ({
  type,
  quantity,
}: {
  type: DurationTypes;
  quantity: number;
}) => {
  switch (type) {
    case DurationTypes.Semester:
      return quantity * 6;
    case DurationTypes.Year:
      return quantity * 12;
    default:
      return quantity;
  }
};

export const toLocaleDateString = (date: string): string => {
  return new Date(date).toLocaleDateString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
  });
};

export const getMonthLabel = (months: number) => {
  const monthOrMonths = months === 1 ? 'mês' : 'meses';
  return `${months} ${monthOrMonths}`;
};
